module.exports = __webpack_public_path__ + "media/fyt_m16.67b3399c.mp4";